import { render } from "./ModalEditar.vue?vue&type=template&id=48d32e21&scoped=true"
import script from "./ModalEditar.vue?vue&type=script&lang=js"
export * from "./ModalEditar.vue?vue&type=script&lang=js"

import "./ModalEditar.vue?vue&type=style&index=0&id=48d32e21&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d32e21"]])

export default __exports__